 <div>
  <form (ngSubmit)="onSubmit()" #f="ngForm">
    <div class="form-group">
      <label for="username" class="form-label font-weight-bold" style="color: black;" >User UPN</label>
      <input type="text" name="username" id="username" class="form-control"
      [(ngModel)]="user.user_upn" required minlength="5" #uname="ngModel" autocomplete="off">
      <span class="text-danger" *ngIf="!uname.valid || uname.untouched">
        <span *ngIf="uname.errors?.required">
          User UPN is required.
        </span>
        <span *ngIf="uname.errors?.minlength">
          User UPN must be at least 5 characters long.
        </span>
      </span>
    </div>

    <!-- <div class="form-group">
      <label for="emailAddress" class="form-label font-weight-bold" style="color: black;" >Email Address</label>
      <input type="text" name="emailAddress" id="emailAddress" class="form-control"
      [(ngModel)]="user.user_email" required minlength="5" #mailAdd="ngModel" autocomplete="off"
      pattern="[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$">
      <span class="text-danger" *ngIf="!mailAdd.valid || mailAdd.untouched ">
        <span *ngIf="mailAdd.errors">
          Email is required in correct format
        </span>

      </span>
    </div> -->

    <mat-form-field class="form-group"  appearance="fill" style="width: 100%;">
      <mat-label class="form-label font-weight-bold " style="color: black;">User role</mat-label>
      <mat-select  name="role" id="role" [(ngModel)]="user.user_role" required
              #role="ngModel" [(value)]="user.user_role">
        <mat-option *ngFor="let item of userRoles" [value]="item" >
          {{item}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="text-center" id="buttons">
      <button mat-raised-button  color="primary"  type="submit" [disabled]="!f.valid">
        <span *ngIf="editMode">Update user</span>
        <span *ngIf="!editMode">Insert user</span>
      </button>
    </div>

  </form>
</div> 



<!-- this is the old code -->




<!-- <div>
  <form (ngSubmit)="onSubmit()" #f="ngForm">
    <div class="form-group">
      <label for="username" class="form-label font-weight-bold" style="color: black;" >Username</label>
      <input type="text" name="username" id="username" class="form-control"
      [(ngModel)]="user.user_email" required minlength="5" #uname="ngModel" autocomplete="off"
      [disabled]="resetPasswordMode">
      <span class="text-danger" *ngIf="!uname.valid || uname.untouched">
        <span *ngIf="uname.errors?.required">
          Username is required.
        </span>
        <span *ngIf="uname.errors?.minlength">
          Username must be at least 5 characters long.
        </span>
      </span>
    </div>

    <div class="form-group">
      <label for="emailAddress" class="form-label font-weight-bold" style="color: black;" >Email Address</label>
      <input type="text" name="emailAddress" id="emailAddress" class="form-control"
      [(ngModel)]="user.email_address" required minlength="5" #mailAdd="ngModel" autocomplete="off"
      pattern="[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
      [disabled]="resetPasswordMode">
      <span class="text-danger" *ngIf="!mailAdd.valid || mailAdd.untouched">
        <span *ngIf="mailAdd.errors">
          Email is required in correct format
        </span>

      </span>
    </div>


    <div class="form-group" *ngIf="!editMode">
      <label for="password" class="form-label font-weight-bold" style="color: black;">Password</label>
      <input type="password" name="password" id="password" class="form-control"
      pattern="^(?=.*[A-Z])(?=.*[-._!&quot;`'#%&amp;,:;&lt;&gt;=@{}~\$\(\)\*\+\/\\\?\[\]\^\|]).{6,100}$"
      [(ngModel)]="userPassword" required minlength="6" #pass="ngModel" autocomplete="off">
      <span class="text-danger" *ngIf="!pass.valid || pass.untouched">
        <span *ngIf="pass.errors?.required">
          Password is required.
        </span>
        <span *ngIf="pass.errors?.minlength || pass.hasError('pattern')">
          Password must be at least 6 characters long upper case, special char. req .
        </span>
      </span>
    </div>

    <div class="form-group" *ngIf="editMode">
    <mat-slide-toggle [(ngModel)]="user.is_active" [checked]="this.user.is_active==1" name="isActive" id="isActive"
    #role="ngModel" [(value)]="user.is_active">User Enabled</mat-slide-toggle>
  </div> -->

  <!-- <div class="form-group" *ngIf="editMode"> -->
    <!-- <mat-form-field class="form-group"  appearance="fill" *ngIf="!resetPasswordMode" style="width: 100%;">
      <mat-label class="form-label font-weight-bold " style="color: black;">User role</mat-label>
      <mat-select  name="role" id="role" [(ngModel)]="user.user_role" required  #role="ngModel" [(value)]="user.user_role">
        <mat-option *ngFor="let item of userRoles" [value]="item" >
          {{item}}
        </mat-option>
      </mat-select>
    </mat-form-field> -->
  <!-- </div> -->


    <!-- <mat-slide-toggle ngModel name="enableWifi">Enable Wifi</mat-slide-toggle> -->

    <!-- <button mat-raised-button  color="primary" (click)="loadLMSelector()" type="button" [hidden]=(editMode||resetPasswordMode)>MARKETS</button>

    <div class="text-center" id="buttons">
      <button mat-raised-button  color="primary"  type="submit" [disabled]="!f.valid || (this.marketsReceivedIds.length==0 && !resetPasswordMode)  || this.editMode==true "
      [hidden]="this.editMode==true ">
        <span *ngIf="editMode">Update user</span>
        <span *ngIf="resetPasswordMode">Reset password</span>
        <span *ngIf="!editMode && !resetPasswordMode">Insert user</span>
      </button> -->

      <!-- <button mat-raised-button  color="primary"  type="submit" [disabled]=" this.editMode==false" [hidden]="this.editMode==false" >Update user</button> -->
    <!-- </div>

  </form>
</div> -->
